export default __webpack_public_path__ + "static/media/rajeevSir.427b1d37.jpg";